import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import CalendarPage from './pages/CalendarPage';
import MyReservationsPage from './pages/MyReservationsPage';
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import AdminUsersPage from './pages/admin/AdminUsersPage';
import AdminReservationsPage from './pages/admin/AdminReservationsPage';
import AdminStatisticsPage from './pages/admin/AdminStatisticsPage';
import ProfilePage from './pages/ProfilePage';
import NotFoundPage from './pages/NotFoundPage';
import PendingApprovalPage from './pages/PendingApprovalPage';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';

function App() {
  const { user, isAuthenticated, checkAuth } = useAuthStore();
  const location = useLocation();
  
  // Check authentication status on app load
  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  // Redirect authenticated users away from auth pages
  const isAuthPage = location.pathname === '/login' || location.pathname === '/register';
  
  if (isAuthenticated && isAuthPage) {
    // If user is pending, redirect to pending page
    if (user?.role === 'PENDING') {
      return <Navigate to="/pending" replace />;
    }
    return <Navigate to="/" replace />;
  }

  // Redirect unauthenticated users to login
  if (!isAuthenticated && !isAuthPage && location.pathname !== '/pending') {
    return <Navigate to="/login" replace />;
  }

  // Handle pending users trying to access non-pending routes
  if (isAuthenticated && user?.role === 'PENDING' && location.pathname !== '/pending') {
    return <Navigate to="/pending" replace />;
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/pending" element={<PendingApprovalPage />} />

      {/* Protected routes */}
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/" element={<CalendarPage />} />
        <Route path="/reservations" element={<MyReservationsPage />} />
        <Route path="/profile" element={<ProfilePage />} />

        {/* Admin routes — already inside the parent <Layout/>, so this only guards
            access and renders an <Outlet/>; wrapping in a second <Layout/> here
            duplicated the navbar. */}
        <Route element={<AdminRoute />}>
          <Route path="/admin" element={<AdminDashboardPage />} />
          <Route path="/admin/users" element={<AdminUsersPage />} />
          <Route path="/admin/reservations" element={<AdminReservationsPage />} />
          <Route path="/admin/statistics" element={<AdminStatisticsPage />} />
        </Route>
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
